let originalFetch = null;
let isFetchWrapped = false;
let resetTimerCallback = null;
let unauthorizedCallback = null;

/**
 * @param {Function|null} callback
 */
export function registerResetTimerCallback(callback) {
    resetTimerCallback = callback;
}

/**
 * @param {Function|null} callback - invoked when an /api/* request returns 401
 */
export function registerUnauthorizedCallback(callback) {
    unauthorizedCallback = callback;
}

/**
 * @param {string|null} urlString
 * @returns {boolean}
 */
function isApiUrl(urlString) {
    if (!urlString) {
        return false;
    }

    if (urlString.startsWith('/api/')) {
        return true;
    }

    if (urlString.includes('://') && urlString.includes('/api/')) {
        try {
            const urlObj = new URL(urlString);
            return urlObj.pathname.startsWith('/api/');
        } catch (e) {
            return urlString.includes('/api/');
        }
    }

    return false;
}

/**
 * @param {string} urlString
 * @returns {boolean}
 */
function shouldSkipUnauthorizedHandler(urlString) {
    return urlString.includes('/api/auth/me') || urlString.includes('/api/auth/logout');
}

/**
 * @param {RequestInfo | URL} url
 * @returns {string|null}
 */
function extractUrlString(url) {
    if (typeof url === 'string') {
        return url;
    }
    if (url instanceof Request) {
        return url.url;
    }
    if (url && typeof url === 'object' && url.url) {
        return url.url;
    }
    return null;
}

/** Install a global fetch wrapper for inactivity tracking and 401 handling. */
export function installFetchWrapper() {
    if (isFetchWrapped) {
        return;
    }

    if (!originalFetch) {
        originalFetch = window.fetch;
    }

    const wrappedFetch = async function (...args) {
        const urlString = extractUrlString(args[0]);
        const isApiCall = isApiUrl(urlString);

        if (isApiCall && resetTimerCallback) {
            resetTimerCallback();
        }

        const response = await originalFetch.apply(this, args);

        if (
            isApiCall
            && response.status === 401
            && urlString
            && !shouldSkipUnauthorizedHandler(urlString)
            && unauthorizedCallback
        ) {
            unauthorizedCallback();
        }

        return response;
    };

    window.fetch = wrappedFetch;
    isFetchWrapped = true;
}

/** @internal test helper */
export function resetFetchWrapperForTests() {
    if (originalFetch) {
        window.fetch = originalFetch;
    }
    originalFetch = null;
    isFetchWrapped = false;
    resetTimerCallback = null;
    unauthorizedCallback = null;
}
